// Inbound provider webhooks (BL-242). Registered for route↔registry parity —
// NOT client-called; `caller: 'webhook'` marks them provider-to-server (same
// treatment as `payments.webhook.finix`). The client never invokes these; the
// entry exists so `api-registry-parity.test.ts` sees a match for the route file.
import { defineAdminRoute } from './define-admin-route';

export const webhooks = {
  resend: defineAdminRoute({
    path: '/api/webhooks/resend',
    params: {},
    // Declared, not bound (BL-1833 PR 4a): Resend sends no staff session.
    methods: {
      POST: {
        grant: { none: 'webhook — the Svix signature (RESEND_WEBHOOK_SECRET) authorizes it' },
        tenant: { from: 'none', reason: 'webhook — one URL for every tenant; the tenant is found from the provider message id' },
      },
    },
    caller: 'webhook',
  }),
};
